import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import StaticTablePaginated from '../../_ui/Table/StaticTablePaginated';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import TableFilterProvider from '../../components/TableFilter/TableFilterProvider';
import { supplierDataChangeColumns } from './SupplierDataChangeColumns';
import {
  supplierDataChangeModule,
  loadServiceProviders,
  clearState
} from './SupplierDataChangeDucks';

const SupplierDataChangeTable = ({
  index,
  tableData,
  loadServiceProviders,
  loading,
  clearState,
  ...rest
}) => {
  const { t, i18n } = useTranslation();
  const filter = useTableFilter(loadServiceProviders, index);
  useEffect(() => clearState, [clearState]);

  return (
    <TableFilterProvider index={filter.index}>
      <StaticTablePaginated
        loading={loading}
        columns={supplierDataChangeColumns(t, i18n.language)}
        data={tableData.content}
        totalElements={tableData.totalElements}
        onClickLoadMore={filter.nextPage}
        {...rest}
      />
    </TableFilterProvider>
  );
};

export default connect(
  state => ({
    loading: state[supplierDataChangeModule].loading,
    tableData: state[supplierDataChangeModule].tableData
  }),
  {
    loadServiceProviders,
    clearState
  }
)(SupplierDataChangeTable);
